<template>
  <div :class="`hc-section__texture --align-y-${position}`" aria-hidden="true" inert="">
    <div class="hc-section__texture-row" v-for="item in 6">
      Every Job Makes The Stay&nbsp;Every Job Makes The Stay&nbsp;Every Job
      Makes The Stay&nbsp;Every Job Makes The Stay&nbsp;Every Job Makes The
      Stay&nbsp;Every Job Makes The Stay&nbsp;Every Job Makes The
      Stay&nbsp;Every Job Makes The Stay&nbsp;Every Job Makes The
      Stay&nbsp;Every Job Makes The Stay&nbsp;
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['position'])
</script>

